document.addEventListener('DOMContentLoaded', function () {

  const panel = document.getElementById('contactPanel');
  const toggleBtn = document.getElementById('toggleContactPanel');

  // Mouse hover → open
  toggleBtn.addEventListener('mouseenter', function () {
    panel.classList.remove('collapsed');
  });

  // Mouse leave → close
  panel.addEventListener('mouseleave', function () {
    panel.classList.add('collapsed');
  });

});
